<template>
	<div class="">
		<!-- Modal Component -->
		<ModalBox v-model="legacyModalVisible" size="lg" hide-close header-class="!hidden" wrapper-classes="lg:h-auto lg:max-h-none p-6">

			<div>
				<div class="flex flex-wrap">
					<div class="md:w-1/2">
						<!-- iframe widget -->
						<div class="placeholder-wrapper">
							<code>Processing playback ..</code>
						</div>
						<iframe
							:src="getPlayerUrl()"
							class="embed"
							frameborder="0"
							width="500"
							height="380"
							allow="autoplay; encrypted-media"
							scrolling="no"
							allowfullscreen
							webkitallowfullscreen
							mozallowfullscreen
							oallowfullscreen
							msallowfullscreen
						/>
					</div>
					<div class="w-full" v-if="active">
						<ul class="list-group-flush">
							<li class="p-2" v-if="!video.dvr">
								<div class="flex flex-wrap">
									<div class="text-s-m text-dark-7 md:w-1/3">
										Video name
									</div>
									<div class="text-s-m truncate text-right w-full">
										{{ video.fileName }}
									</div>
								</div>
							</li>
							<li class="p-2" v-if="video.dvr">
								<div class="flex flex-wrap">
									<div class="text-s-m text-dark-7 md:w-1/3">
										Duration
									</div>
									<div class="text-s-m text-right md:w-2/3">
										{{ video.durationText }} {{ video.abbr }}
									</div>
								</div>
							</li>
							<li class="p-2" v-if="!video.dvr">
								<div class="flex flex-wrap">
									<div class="text-s-m text-dark-7 md:w-1/3">
										File Size
									</div>
									<div class="text-s-m text-right md:w-2/3">
										<span
											v-if="video.bytes"
											class="value"
										>
											{{ bytes(video.bytes) }}
										</span>
										<span v-else>
											-
										</span>
									</div>
								</div>
							</li>
							<li class="p-2" v-if="video.mediaInfo">
								<div class="flex flex-wrap">
									<div class="text-s-m text-dark-7 md:w-1/3">
										Duration
									</div>
									<div class="text-s-m truncate text-right md:w-2/3">
										<span v-if="video.mediaInfo.duration<60">{{ video.mediaInfo.duration }} <small>SECS</small> </span>
												<span v-else-if="video.mediaInfo.duration">{{ numberFormat(video.mediaInfo.duration/60) }} <small>MINS</small> </span>
									</div>
								</div>
							</li>
							<li class="p-2" v-if="video.mediaInfo && video.mediaInfo.width">
								<div class="flex flex-wrap">
									<div class="text-s-m text-dark-7 md:w-1/3">
										Media Source
									</div>
									<div class="text-s-m truncate text-right md:w-2/3">
									<span>{{ video.mediaInfo.width }} x {{ video.mediaInfo.height }}</span>
									</div>
								</div>
							</li>
							<li  class="p-2" v-if="!video.dvr">
								<div class="flex flex-wrap">
									<div class="text-s-m text-dark-7 md:w-1/3">
										Codecs
									</div>
									<div class="text-s-m text-right md:w-2/3">
										<div v-if="video.mediaInfo && video.mediaInfo.codec">
											
											
											<!-- media codecs -->
											<div v-if="video.mediaInfo && video.mediaInfo.codecs">
												<Badge
													v-for="(codec, index) in video.mediaInfo.codecs.filter(({ type}) => type !== 'general')"
													:key="index"
													class="badge_sm ml-2 text-500"
													type="main"
												>{{ codec.codec }}</Badge>
											</div>
										</div>
										<div v-else>
											n/a
										</div>
									</div>
								</div>
							</li>
							<li  class="p-2" v-if="!video.dvr">
								<div class="flex flex-wrap">
									<div class="text-s-m text-dark-7 md:w-1/3">
										Created Date
									</div>
									<div class="text-s-m text-right md:w-2/3">
										{{ date(video.creationTime) }}
									</div>
								</div>
							</li>
						</ul>
					</div>
					<FormButton
						type="light" :isIcon="true"
						size="md"
						@click="onConfirm"
						class="absolute top-3 right-3 z-10"
					>
						<IconBase width-view-box="12" height-view-box="12" class="text-dark-6">
						<IconClose />
					</IconBase>
					</FormButton>
				</div>
			</div>
		
</ModalBox>
	</div>
</template>

<script>
import ModalBox from '@/components/modals/ModalBox.vue'
import { legacyModalBridgeMixin } from '@/composables/useLegacyModalBridge'
import Badge from '@/components/Badge.vue';
import FormButton from '@/components/Atoms/FormButton.vue';
import IconBase from '@/components/icon/IconBase.vue';
import IconClose from '@/components/icon/IconClose.vue';
import { bytes, date, numberFormat } from '@/filtersNew';

export default {
	name: 'VodVideoModal',
	mixins: [legacyModalBridgeMixin],
	legacyModalId: 'modal-vod-video',
	components: {
		ModalBox,
		Badge,
		FormButton,
		IconBase,
		IconClose
	},
	props: {
		video: {
			type: Object,
			required: true
		}
	},
	data() {
		return {
			processing: false,
			active: false
		};
	},
	mounted () {
	},
	methods: {
		bytes,
		date,
		numberFormat,
		onLegacyModalShow() {
			this.onInit();
		},
		onLegacyModalHide() {
			this.onDismiss();
		},
		onInit() {
			this.active = true;
		},
		onDismiss() {
			this.active = false;
		},
		onConfirm() {
			this.$emit('modal-confirm');
			this.dismiss();
		},
		dismiss() {
			this.hideLegacyModal();
			// lazy clear
			setTimeout(() => {
				this.processing = false;
			}, 1000);
		},
		getPlayerUrl () {
			const video = this.video;
			if (video.dvr) {
				const range = `${video.from}-${video.duration}`
				return `${process.env.VUE_APP_PLAYER_APP_BASE_URL}/vod/${video.streamKey}?range=${range}&preview=true&abr=${video.abr ? 'true' : 'false'}&server=${video.server}`;
			}

			if (video.archive) {
				const range = `${video.archive.from}-${video.archive.duration}`
				return `${process.env.VUE_APP_PLAYER_APP_BASE_URL}/${video.archive.key}?range=${range}&preview=true&abr=${video.archive.abr ? 'true' : 'false'}`
							+ (video.archive.namedHls ? '&namedHls=true' : '')
							+ (video.archive.cap ? '&cap=true' : '');
			}

			if (!this.active) return;
			// let playerUri = `https://player.castr.io/vod/${video.id}`
			const playerUri = `${process.env.VUE_APP_PLAYER_APP_BASE_URL}/vod/${video.id}?preview=true`;
			return playerUri;
		}
	},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.placeholder-wrapper {
  position: absolute;
  width: 100%;
  text-align: center;
  margin-top: 50px;
  z-index:0;
}
iframe.embed {
  max-width: 100%;
  height: 420px;
  margin: 0;
  padding: 0;
  margin-bottom: -7px;
  position: relative;
  z-index:1;
}
.btn-icon {
	top: -15px;
	right: -10px;
}
.btn-close {
	z-index: 9;
}
</style>
